

















export default {
  props: {
    orderId: { type: String, required: true },
    orderIsCanceled: { type: Boolean, default: false },
    orderIsNew: { type: Boolean, default: false }
  },
  computed: {},
  methods: {}
}
